import { MapTo } from '@adobe/cq-react-editable-components';
import React, { Component } from 'react';
import ModalFooterCTA from './ModalFooterCTA';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import styled from 'styled-components';

const ButtonContainer = styled.div`
  padding: 32px 48px;
  box-shadow: inset 0 1px 0 0 ${tokens.ColorWhite200};
  background-color: rgba(0, 104, 148, 0.04);
  text-align: right;

  @media (max-width: 767px) {
    padding: 0 16px 24px;
    box-shadow: none;
    background-color: #ffffff;
    text-align: center;
    width: calc(100vw - 32px);
    position: absolute;
    bottom: 0;
  }
`;

const ModalFooterCTAEditConfig = {
  emptyLabel: 'Modal Footer CTA',

  isEmpty: function(props: any): boolean {
    return !props;
  },
};

class ModalFooterCTAWrapper extends Component {
  props: any;

  render(): JSX.Element {
    const modalFooterCTAProps = {
      title: this.props.buttonTitle,
      onClick: this.props.onClick,
      type: this.props.type,
    };

    return (
      <ButtonContainer>
        <ModalFooterCTA {...modalFooterCTAProps} />
      </ButtonContainer>
    );
  }
}

export default MapTo('workplace-spa/components/modal-footer-cta')(ModalFooterCTAWrapper, ModalFooterCTAEditConfig);
